define([
    'common/ui/view/svg/index'
], function(
    SVGView
    ){
    var IconView = SVGView.extend(
        {
            className: 'faicon',

            initialize: function(params) {
                IconView.__super__.initialize.call(this, params);
                this.params = params;
                this._offset = params.offset ? params.offset : {x: 0, y: 0};
                this._size = params.size;
                this._fontSize = params.fontSize ? params.fontSize : params.size;
                this._color = params.color;
                this._class = params.class;
                this._bgclass = params.bgclass;
                this._text = params.text;
            },

            render: function() {
                var x = this._offset.x - this._size / 2;
                var y = this._offset.y - this._size / 2;
                var bg = this.$el.append('foreignObject')
                    .attr('width', this._size)
                    .attr('height', this._size)
                    .attr('transform', function(){
                        return 'translate(' + x + ',' + y + ')';
                    })
                    .append('xhtml:div')
                    .style('height', this._size)
                    .style('text-align', 'center')
                    .style('vertical-align', 'middle')
                    .style('line-height', this._size + 'px')
                    .style('font-size', this._fontSize + 'px')
                    .style('color', this._color);

                if(this._bgclass) {
                    bg.classed(this._bgclass, true);
                }

                var span = bg.append('xhtml:span');

                if(this._class) {
                    span.attr('class', this._class);
                }
                if(this._text) {
                    span.html(this._text);
                }

                return this;
            }
        });

    return IconView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/icon.js